<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 8.25C16.8922 8.25 17.6284 8.9176 17.7364 9.78048L17.75 10V14.25H22C22.9665 14.25 23.75 15.0335 23.75 16C23.75 16.8922 23.0824 17.6284 22.2195 17.7364L22 17.75H17.75V22C17.75 22.9665 16.9665 23.75 16 23.75C15.1078 23.75 14.3716 23.0824 14.2636 22.2195L14.25 22V17.75H10C9.0335 17.75 8.25 16.9665 8.25 16C8.25 15.1078 8.9176 14.3716 9.78048 14.2636L10 14.25H14.25V10C14.25 9.0335 15.0335 8.25 16 8.25Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AddIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
